import React, { useState, useEffect } from 'react'
import { Card, Table, Button, Modal, Form, message, Tag, Space, Tabs, Badge, Tooltip } from 'antd'
import { DollarOutlined, SplitCellsOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import { useSelector } from 'react-redux'
import {
  getUnallocatedPayments,
  getSplitPayments,
  allocatePayment
} from '../../backend-integration/api/paymentAllocation'
import UnallocatedPaymentsList from './UnallocatedPaymentsList'
import SplitPaymentsList from './SplitPaymentsList'
import AllocationModal from './AllocationModal'

const { TabPane } = Tabs

const PaymentAllocationManager = () => {
  const authState = useSelector((state) => state.auth)
  const user = authState?.agiliteUser
  const [activeTab, setActiveTab] = useState('unallocated')
  const [unallocatedCount, setUnallocatedCount] = useState(0)
  const [splitCount, setSplitCount] = useState(0)
  const [selectedPayment, setSelectedPayment] = useState(null)
  const [allocationModalVisible, setAllocationModalVisible] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    fetchCounts()
  }, [refreshKey])

  const fetchCounts = async () => {
    try {
      const [unallocated, split] = await Promise.all([
        getUnallocatedPayments({ countOnly: true }),
        getSplitPayments({ countOnly: true })
      ])
      setUnallocatedCount(unallocated.count)
      setSplitCount(split.count)
    } catch (error) {
      console.error('Error fetching counts:', error)
    }
  }

  const handleAllocate = (payment) => {
    setSelectedPayment(payment)
    setAllocationModalVisible(true)
  }

  const handleAllocationComplete = () => {
    setAllocationModalVisible(false)
    setSelectedPayment(null)
    setRefreshKey((prev) => prev + 1)
    message.success('Payment allocated successfully')
  }

  const tabItems = [
    {
      key: 'unallocated',
      label: (
        <span>
          <ClockCircleOutlined />
          Unallocated Payments
          <Badge count={unallocatedCount} style={{ marginLeft: 8 }} />
        </span>
      ),
      children: <UnallocatedPaymentsList onAllocate={handleAllocate} refreshKey={refreshKey} />
    },
    {
      key: 'split',
      label: (
        <span>
          <SplitCellsOutlined />
          Split Payments
          <Badge count={splitCount} style={{ marginLeft: 8 }} />
        </span>
      ),
      children: <SplitPaymentsList refreshKey={refreshKey} />
    }
  ]

  return (
    <Card title='Payment Allocation'>
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />

      <Modal
        title='Allocate Payment'
        visible={allocationModalVisible}
        onCancel={() => setAllocationModalVisible(false)}
        footer={null}
        width={800}
      >
        <AllocationModal
          payment={selectedPayment}
          onComplete={handleAllocationComplete}
          onCancel={() => setAllocationModalVisible(false)}
        />
      </Modal>
    </Card>
  )
}

export default PaymentAllocationManager
